<template>
  <div v-resize="resizeChatbox" class="message-item">
    <!-- question -->
    <template v-if="message.messagetype != 'replycomment'">
      <ReplyAds
        v-if="adsRef"
        :ad-data="adsRef"
        class="text-xs-center small my-4"
        style="font-size: small"
      />

      <LivechatFacebookPostLink :value="value" />

      <template v-if="message.questiontype">
        <template v-if="message.questiontype == 'ad_id'">
          <AdsData
            :ad-id="message.questiondata"
            class="text-xs-center small my-4"
            style="font-size: small"
          >
            <template #default="{ item }">
              <template v-if="item && item.creative && (item.creative.title || item.creative.name)">
                {{ $t('this_message_was_replied_from_ads', { ad_id: message.questiondata }) }}
                {{ item.creative.title || item.creative.name }}
              </template>
            </template>
          </AdsData>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="message.questiontype == 'failed'">
          <!-- No question data -->
        </template>
        <div
          v-else-if="
            (message.questiontype != 'comment' ||
              (message.questiontype == 'comment' && message.questiondata)) &&
            message.questiontype != 'noreply' &&
            message.questiondata != '{image}' &&
            message.questiondata != '{video}'
          "
          class="receiver"
        >
          <div class="user">
            <template v-if="selectedUser && selectedUser.profile_pic">
              <v-avatar :size="15" color="grey lighten-4">
                <img class="profile" :src="selectedUser.profile_pic" alt />
              </v-avatar>
            </template>
          </div>
          <div
            class="message"
            style="position: relative"
            :style="{ 'max-width': maxwidth ? maxwidth + 'px' : 'auto' }"
          >
            <message-viewer
              v-model="parseQuestionMessage"
              :channel="$store.state.livechat.app"
              :size="'small'"
              :font-size="'15px'"
              :show-profile="false"
              :align="'left'"
              :message-id="messageId"
              :data="value"
            ></message-viewer>
            <div align="left" style="height: 0.5em">
              <small style="position: relative; bottom: 1.3em">{{
                value.timestamp | DateFormat('DD/MM/YYYY HH:mm')
              }}</small>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </template>

      <!-- answer -->
      <div
        v-if="
          (value.answerby != '' || value.answerby == 'bot') &&
          parseAnswerMessage[0] &&
          parseAnswerMessage[0].length > 0 &&
          message.messagetype != 'noreply'
        "
        class="sender"
        :class="{ bot: value.answerby == 'bot' }"
      >
        <div v-if="message.questiontype && message.questiontype == 'failed'" class="pa-2">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon small class="red--text" style="cursor: pointer" v-on="on">error</v-icon>
            </template>
            <span>{{ message.questiondata }}</span>
          </v-tooltip>
        </div>
        <div
          class="message"
          style="position: relative"
          :style="{ 'max-width': maxwidth ? maxwidth + 'px' : 'auto' }"
        >
          <message-viewer
            v-model="parseAnswerMessage"
            :channel="$store.state.livechat.app"
            :size="'small'"
            :font-size="'15px'"
            :show-profile="false"
            :background="
              !['102052945584054', '106855151601601'].includes(livechat.pageid)
                ? undefined
                : '#ffa899'
            "
            :align="value.answerby != '' || value.answerby == 'bot' ? 'right' : 'left'"
          ></message-viewer>
          <div align="right" style="height: 0.5em">
            <small style="position: relative; bottom: 1.3em">
              <template v-if="[...$store.state.bbqPage].includes(livechat.pageid)">
                <template v-if="value.userread && value.userread_timestamp">
                  {{ $t('read') }}
                </template>
              </template>
              {{ value.timestamp | DateFormat('DD/MM/YYYY HH:mm  -  ') }}
            </small>

            <template v-if="value.answerby == 'admin'">
              <small v-if="adminName" style="position: relative; bottom: 1.3em">{{
                adminName
              }}</small>
              <small v-else style="position: relative; bottom: 1.3em">admin</small>
            </template>
            <template v-else>
              <small style="position: relative; bottom: 1.3em">Bot</small>
            </template>
          </div>
        </div>
        <div class="user">
          <v-avatar :size="15" color="grey lighten-4">
            <img
              class="profile"
              :src="'https://graph.facebook.com/' + $store.state.livechat.pageid + '/picture'"
              alt
            />
          </v-avatar>
        </div>
        <div class="clearfix"></div>
      </div>
    </template>
    <template v-else>
      <template v-if="message.intent">
        <template v-if="message.intent == '{default_comment_to_inbox}'">
          <AdsData
            :ad-id="message.questiondata"
            class="text-xs-center small my-4"
            style="font-size: small"
          />
          <div class="clearfix"></div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageViewer from '@/components/elements/MessageViewer'
import moment from 'moment'
import axios from 'axios'

import AdsData from './AdsData'
import ReplyAds from './ReplyAds'
import LivechatFacebookPostLink from './LivechatFacebookPostLink'

export default {
  components: {
    MessageViewer,
    AdsData,
    LivechatFacebookPostLink,
    ReplyAds
  },
  filters: {
    DateFormat(v) {
      return moment(v).format('DD-MM-YYYY HH:mm')
    }
  },
  props: ['value', 'receiver', 'userAns', 'messageId'],
  data: function () {
    return {
      message: this.value,
      isError: false,
      maxwidth: null
    }
  },

  computed: {
    adminName() {
      var vm = this
      if (vm.value.adminid) {
        if (/^\d+$/.test(vm.value.adminid)) {
          var result = vm.$store.state.facebook_users_name.find((el) => el.id == vm.value.adminid)
          if (result) return result.name
        } else {
          return vm.value.adminid
        }
      }
      return ''
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      selectedUser: 'getCurrentUser',
      livechat: 'livechat'
    }),
    isReceiver: function () {
      // sender == admin and bot
      // receiver == customer
      return this.value.answerby == ''
    },
    adsRef() {
      return this.value && this.value.ads_ref ? this.value.ads_ref : null
    },
    parseAnswerMessage: function () {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.messagedata
      var chattype = vm.message.messagetype
      // console.log(chattype, chatdetail)

      if (chattype == 'template') {
        if (vm.message.intent == '{welcome}') {
          messages = [
            [
              {
                type: 'welcome_message'
              }
            ]
          ]
        } else {
          try {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail),
                  ratio: vm.message.ratio == 'horizontal' ? 'horizontal' : 'square'
                }
              ]
            ]
          } catch (error) {
            messages = [
              [
                {
                  type: 'text',
                  text: chatdetail
                }
              ]
            ]
          }
        }
      } else if (chattype == 'text' && chatdetail.includes('{welcome_message}')) {
        messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (chattype == 'json' || chattype == 'replyinbox') {
        try {
          var message = JSON.parse(chatdetail)
          messages[0] = message
        } catch (error) {
          vm.isError = true
        }
      } else if (chattype == 'noreply' || chatdetail == '') {
        vm.$set(vm.message, 'messagetype', 'noreply')
      } else {
        try {
          var newGroup = []
          // console.log(chatdetail)
          var group = chatdetail.split('||')
          // eslint-disable-next-line no-undef
          $.each(group, function (index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            // eslint-disable-next-line no-undef
            $.each(group_messages, function (index, message) {
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else if (vm.isImageURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
            })
            newGroup.push(newMessage)
          })
          messages = newGroup
        } catch (error) {
          console.error(error)
        }
      }

      return messages
    },
    parseQuestionMessage: function () {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.questiondata
      var chattype = vm.message.questiontype
      if (chattype) {
        if (chattype == 'template') {
          if (vm.message.intent == '{welcome}') {
            messages = [
              [
                {
                  type: 'welcome_message'
                }
              ]
            ]
          } else {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail),
                  ratio: vm.message.ratio == 'horizontal' ? 'horizontal' : 'square'
                }
              ]
            ]
          }
        } else if (chattype == 'json') {
          try {
            // messages = JSON.parse(chatdetail)
            var message = JSON.parse(chatdetail)
            messages[0] = message
          } catch (error) {
            vm.isError = true
          }
        } else if (chattype == 'noreply' || chatdetail == '') {
          vm.$set(vm.message, 'questiontype', 'noreply')
        } else if (chattype == 'image') {
          messages = [
            [
              {
                type: 'image',
                image_url: chatdetail
              }
            ]
          ]
        } else if (chattype == 'video') {
          if (vm.message.intent == '{video}') {
            messages = [
              [
                {
                  type: 'video',
                  video_url: chatdetail
                }
              ]
            ]
          }
        } else if (chattype == 'audio') {
          if (vm.message.intent == '{audio}') {
            messages = [
              [
                {
                  type: 'audio',
                  audio_url: chatdetail
                }
              ]
            ]
          }
        } else if (chattype == 'file') {
          if (chattype == 'file') {
            messages = [
              [
                {
                  type: 'file',
                  data: chatdetail,
                  filename: vm.message.intent
                }
              ]
            ]
          }
        } else if (chattype == 'follow') {
          messages = [
            [
              {
                type: 'text',
                text: 'Get Started'
              }
            ]
          ]
        } else if (chattype == 'share') {
          messages = [
            [
              {
                type: 'share',
                image_url: chatdetail
              }
            ]
          ]
        } else if (chatdetail.indexOf('talk_to_human') > 0) {
          const objectMessage = JSON.parse(chatdetail)
          messages = [
            [
              {
                type: 'talk_to_human',
                text: objectMessage.data.displayText,
                payload: objectMessage.data
              }
            ]
          ]
        } else {
          var newGroup = []
          try {
            var group = chatdetail.split('||')
            // eslint-disable-next-line no-undef
            $.each(group, function (index, messages) {
              var newMessage = []
              var group_messages = messages.split('#nl')
              // eslint-disable-next-line no-undef
              $.each(group_messages, function (index, message) {
                if (!isNaN(message)) {
                  newMessage.push({
                    type: 'text',
                    text: message
                  })
                } else if (vm.isJsonParseable(message)) {
                  var messageParsed = JSON.parse(message)
                  // Customize for deeple payload
                  if (messageParsed.displayText || messageParsed.categoryName) {
                    newMessage.push({
                      type: 'text',
                      text: messageParsed.displayText || messageParsed.categoryName
                    })
                  } else {
                    // zwiz
                    newMessage.push({
                      text: messageParsed.text,
                      buttons: messageParsed.buttons,
                      type: 'button'
                    })
                  }
                } else {
                  newMessage.push({
                    type: 'text',
                    text: message
                  })
                }
                // else if (vm.isURL(message)) {
                //   newMessage.push({
                //     type: 'image',
                //     image_url: message
                //   })
                // }
              })
              newGroup.push(newMessage)
            })
            messages = newGroup
          } catch (error) {
            let newMessage = []
            newMessage.push({ type: 'text', text: chatdetail })
            newGroup.push(newMessage)
          }
        }
      }
      return messages
    }
  },
  watch: {
    value: function (newVal) {
      this.message = newVal
    }
  },
  mounted() {
    if (this.value.adminid && /^\d+$/.test(this.value.adminid)) this.getFbName(this.value.adminid)
  },
  methods: {
    resizeChatbox() {
      var vm = this
      vm.$nextTick(function () {
        vm.maxwidth = document.getElementById('chatbox').clientWidth - 10
      })
    },
    async getFbName(userid) {
      var vm = this
      var fbusersname = vm.$store.state.facebook_users_name
      if (!fbusersname.some((el) => el.id == userid))
        var result = await axios.get(
          `https://graph.facebook.com/${userid}?fields=name&access_token=${vm.selectedBot.page_access_token}`
        )
      if (result) {
        vm.$store.state.facebook_users_name.push(result.data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  margin: 5px;
}
.receiver {
  display: flex;
  white-space: nowrap;

  .user {
    margin-right: 5px;
  }
}
.sender {
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;

  .user {
    margin-left: 5px;
  }
}
.messageTime {
  position: absolute;
  bottom: -7px;
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-message.vue